export default __webpack_public_path__ + "static/media/git.59eeb5c5.png";